import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=ec632a84&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ec632a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec632a84",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/signIn/index.vue"
export default component.exports